<template>
    <div class="modal-content-padding">
        <div class="form-group row">
            <label class="col-sm-2 col-form-label">{{ $t('name') }}</label>
            <div class="col-sm-4">
                <input
                    type="text"
                    class="form-control"
                    id="name"
                    v-model="address.name"
                    data-vv-as="Name"
                    data-vv-name="name"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.has('name') }"
                />
                <div class="invalid-feedback" style="display: block">
                    <span>{{ errors.first('name') }}</span>
                </div>
            </div>
            <label class="col-sm-2 col-form-label">{{ $t('email') }}</label>
            <div class="col-sm-4">
                <input
                    type="email"
                    class="form-control"
                    id="email"
                    v-model="address.email"
                    data-vv-as="Email"
                    data-vv-name="email"
                    v-validate="'required|email'"
                    :class="{ 'is-invalid': errors.has('email') }"
                />
                <div class="invalid-feedback" style="display: block">
                    <span>{{ errors.first('email') }}</span>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-2 col-form-label">Phone</label>
            <div class="col-sm-4">
                <input type="text" class="form-control" id="phone" v-model="address.phone" />
            </div>
            <label class="col-sm-2 col-form-label">{{ $t('country') }}</label>
            <div class="col-sm-4">
                <input type="text" class="form-control" id="country" v-model="address.country" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-2 col-form-label">{{ $t('city') }}</label>
            <div class="col-sm-4">
                <input type="text" class="form-control" v-model="address.city" />
            </div>
            <label class="col-sm-2 col-form-label">{{ $t('street') }}</label>
            <div class="col-sm-4">
                <input type="text" class="form-control" id="street" v-model="address.street" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-2 col-form-label">{{ $t('zip') }}</label>
            <div class="col-sm-4">
                <input type="text" class="form-control" id="zip_code" v-model="address.zip_code" />
            </div>
            <label class="col-sm-2 col-form-label">Region</label>
            <div class="col-sm-4">
                <input type="text" class="form-control" id="region" v-model="address.region" />
            </div>
        </div>
        <button class="btn btn-success" v-on:click="saveAddress">{{ $t('create') }}</button>
    </div>
</template>
<script>
import { handleAxiosError, setAddress } from '@/services/axiosService';

export default {
    props: ['fetch'],
    data() {
        return {
            address: {
                name: '',
                country: '',
                region: '',
                city: '',
                street: '',
                zip_code: '',
                phone: '',
                email: ''
            }
        };
    },
    methods: {
        async saveAddress() {
            try {
                this.$validator.validate();
                if (this.isFormInvalid()) {
                    return;
                }
                await setAddress(this.address);
                this.fetch();
                this.$emit('close');
            } catch (error) {
                handleAxiosError(error);
            }
        },
        isFormInvalid() {
            return Object.keys(this.fields).some(key => this.fields[key].invalid);
        }
    }
};
</script>
